import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-asignacion-personal',
  templateUrl: './asignacion-personal.component.html',
  styleUrls: ['./asignacion-personal.component.css']
})
export class AsignacionPersonalComponent implements OnInit {
  isLoading: boolean = false;
  dataSource: any;
  proveedores: any[] = [];
  displayedColumns: string[] = [
    'days',
    'nombreServicio',
    'tipoServicio',
    'categoriaServicio',
    'cantidad',
    'proveedor'
  ];

  myControl = new FormControl(<string | any>'');
  currentProviders: any[] = [];
  defaultProvider!: any;
  uniqueServices!: any[];
  proveedoresAsignadosPorDia: { [dia: number]: string[] } = {};

  filteredProviders: any[] = [];

  selectedTipoProveedor: string | null = null;
  arrayTipoProveedor: any = [];

  selectedComunidad: string | null = null;
  arrayComunidad: any = [];

  selectedLocacion: string | null = null;
  arrayLocacion: any = [];

  displaySelection: boolean = false;
  location: string | null = null;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private readonly fileService: FileService,
    private readonly aventuraService: AventuraService,
    public dialogRef: MatDialogRef<AsignacionPersonalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get communityRestrictionText(): string {
    const comunidad = this.data?.productAventura?.comunidad;
    const isHuaraz = this.data?.location?.toLowerCase() === 'huaraz';
    const isCusco = this.data?.location?.toLowerCase() === 'cusco';

    if (Array.isArray(comunidad) && comunidad.length > 0) {
      return `Comunidades requeridas por el producto: ${comunidad.join(', ')}`;
    } else if (typeof comunidad === 'string' && comunidad.trim() !== '') {
      return `Comunidad requerida por el producto: ${comunidad}`;
    }

    if (isHuaraz) {
      return 'Comunidades permitidas: Huaraz, Cordillera Blanca, Cordillera Huayhuash (se excluyen proveedores de Cusco)';
    } else if (isCusco) {
      return 'Comunidades permitidas: Camicancha, Huilloq, Lamay, Socma, Poroy, Ocongate, Machu Picchu (se excluyen proveedores de Huaraz)';
    }
    return '';
  }

  ngOnInit(): void {
    const categoria = (
      this.data?.productAventura?.objProducto?.categoriaProducto || ''
    )
      .replace(/\s+/g, '')
      .toUpperCase();

    if (this.data?.serviceCategory !== 'GUIA') {
      this.displaySelection = true;
    } else if (categoria === 'BIKINGADVENTURES') {
      this.displaySelection = true;
    } else {
      this.displaySelection = false;
    }

    if (this.data.productAventura.filePadreId) {
      this.displayedColumns.splice(0, 0, 'ssff');
    }

    //this.uniqueServices = this.showUniqueServices(this.data.servicios)
    this.uniqueServices = this.data.serviciosUnique;

    this.uniqueServices = this.uniqueServices.sort((a: any, b: any) => {
      return parseInt(a.days[0]) - parseInt(b.days[0]);
    });

    this.dataSource = new MatTableDataSource();

    this.getProviderByName();
    this.getProviders();
  }

  compareProviders = (p1: any, p2: any): boolean => {
    return p1 && p2 ? p1.id === p2.id : p1 === p2;
  };

  changed(element: any) {
    if (!element.selected) {
      element.selected = [...(element.proveedores || [])];
    }
    if (!element.allProv) {
      element.allProv = [...(element.proveedores || [])];
    }

    const proveedorAdded = element.proveedores?.find(
      (provider: any) => !element.selected.some((p: any) => p.id === provider.id)
    );
    const proveedorDeleted = element.selected?.find(
      (provider: any) => !element.proveedores.some((p: any) => p.id === provider.id)
    );

    // 1. VALIDACIÓN PREVENTIVA: Si se intenta desmarcar un proveedor que ya tiene OS, bloquear antes de alterar allProv
    if (proveedorDeleted) {
      const serviciosConOSDelProveedor = this.data.servicios.filter(
        (serv: any) =>
          this.isSameService(serv, element) &&
          serv.providerId === proveedorDeleted.id &&
          Boolean(
            serv.orderId ||
              (serv.numOS && serv.numOS.toString().trim() !== '')
          )
      );

      if (serviciosConOSDelProveedor.length > 0) {
        // Restaurar inmediatamente el proveedor en proveedores y allProv
        if (!element.proveedores.some((p: any) => p.id === proveedorDeleted.id)) {
          element.proveedores = [...element.proveedores, proveedorDeleted];
        }
        if (!element.allProv.some((p: any) => p.id === proveedorDeleted.id)) {
          element.allProv = [...element.allProv, proveedorDeleted];
        }
        element.selected = [...element.proveedores];

        setTimeout(() => {
          element.proveedores = [...element.selected];
          element.allProv = [...element.selected];
        });

        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'No puedes deseleccionar este proveedor',
          text: 'Este proveedor ya cuenta con Órdenes de Servicio asignadas',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
    }

    // 2. VALIDACIÓN: Máximo permitido al agregar proveedores
    let lengthArray = element.proveedores.length;
    const maxPermitido = element?.cantPersonal ?? 1;

    if (lengthArray > maxPermitido) {
      if (proveedorAdded) {
        element.proveedores = element.proveedores.filter(
          (provider: any) => provider.id !== proveedorAdded.id
        );
        setTimeout(() => {
          element.proveedores = [...element.selected];
        });

        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: `Máximo ${maxPermitido} proveedores permitidos`,
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
    }

    const diasFilaActual = element.days || [];

    // 3. Procesar proveedor agregado
    if (proveedorAdded) {
      let chocaMismoDia = false;
      for (const dia of diasFilaActual) {
        if (this.proveedoresAsignadosPorDia[dia]) {
          if (
            this.proveedoresAsignadosPorDia[dia].some(
              (p: any) => (p.id ? p.id === proveedorAdded.id : p === proveedorAdded)
            )
          ) {
            chocaMismoDia = true;
            break;
          }
        }
      }

      if (chocaMismoDia) {
        element.proveedores = element.proveedores.filter(
          (provider: any) => provider.id !== proveedorAdded.id
        );
        setTimeout(() => {
          element.proveedores = [...element.selected];
        });

        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'Este proveedor ya fue seleccionado en el mismo día',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }

      if (!element.allProv.some((p: any) => p.id === proveedorAdded.id)) {
        element.allProv.push(proveedorAdded);
      }

      for (const dia of diasFilaActual) {
        if (!this.proveedoresAsignadosPorDia[dia]) {
          this.proveedoresAsignadosPorDia[dia] = [];
        }
        if (
          !this.proveedoresAsignadosPorDia[dia].some(
            (p: any) => (p.id ? p.id === proveedorAdded.id : p === proveedorAdded)
          )
        ) {
          this.proveedoresAsignadosPorDia[dia].push(proveedorAdded);
        }
      }
    } else if (proveedorDeleted) {
      // 4. Procesar eliminación permitida (sin OS)
      element.allProv = element.allProv.filter(
        (provider: any) => provider.id !== proveedorDeleted.id
      );

      for (const dia of diasFilaActual) {
        if (this.proveedoresAsignadosPorDia[dia]) {
          this.proveedoresAsignadosPorDia[dia] =
            this.proveedoresAsignadosPorDia[dia].filter((provider: any) =>
              provider.id
                ? provider.id !== proveedorDeleted.id
                : provider !== proveedorDeleted
            );
        }
      }
    }

    // ⚠️ CRÍTICO: Actualizar element.selected AL FINAL SIEMPRE
    element.selected = [...element.proveedores];
  }

  getProviderByName() {
    this.fileService.getProviderByName('EXPLORANDES CUSCO').subscribe((res) => {
      this.defaultProvider = res.getProviderByName;
    });
  }

  async getProviders() {
    this.isLoading = true;
    this.proveedores = (
      await firstValueFrom(this.aventuraService.getAllProveedoresByType('GUIA'))
    ).getAllProviderByType;

    const personalCampoProviders = (
      await firstValueFrom(
        this.aventuraService.getAllProveedoresByType('PERSONALDECAMPO')
      )
    ).getAllProviderByType;

    this.proveedores = this.proveedores.concat(personalCampoProviders);

    this.proveedores = this.proveedores.filter(
      (proveedor) =>
        proveedor?.locacion == null ||
        proveedor?.locacion.trim().toLowerCase() ===
          this.data?.location.trim().toLowerCase()
    );

    this.proveedores = this.proveedores.filter((proveedor) =>
      this.data.comunidad && this.data.serviceCategory === 'PORTEADOR'
        ? this.data.comunidad.includes(
            proveedor.personalCampoInfo?.comunidad || proveedor.direccionLegal
          )
        : this.data.serviceCategory === 'PORTEADOREXTRA'
          ? proveedor.personalCampoInfo?.comunidad === 'CHAMANA'
          : true
    );

    if (this.data.location?.toLowerCase() === 'huaraz') {
      // Available communities: HUARAZ ; HUAYHUASH ; BLANCA
      this.proveedores = this.proveedores.filter((proveedor) => {
        const comunidadProveedor = (
          proveedor.personalCampoInfo?.comunidad || ''
        ).toUpperCase();

        if (!this.data.productAventura.comunidad?.length) {
          return (
            !comunidadProveedor.includes('CAMICANCHA') &&
            !comunidadProveedor.includes('HUILLOQ') &&
            !comunidadProveedor.includes('LAMAY') &&
            !comunidadProveedor.includes('SOCMA') &&
            !comunidadProveedor.includes('POROY') &&
            !comunidadProveedor.includes('OCONGATE') &&
            !comunidadProveedor.includes('MACHU PICCHU')
          );
        }

        return this.data.productAventura.comunidad?.some((com: string) => {
          const search = com.toUpperCase();
          if (search.includes('HUAYHUASH'))
            return comunidadProveedor.includes('HUAYHUASH');
          if (search.includes('BLANCA'))
            return comunidadProveedor.includes('BLANCA');
          if (search.includes('HUARAZ'))
            return comunidadProveedor.includes('HUARAZ');
          return;
        });
      });
    }
    if (this.data.location?.toLowerCase() === 'cusco') {
      // Available comunities: CAMICANCHA ; HUILLOQ ; LAMAY ; SOCMA ; POROY ; OCONGATE ; MACHU PICCHU
      this.proveedores = this.proveedores.filter((proveedor) => {
        const comunidadProveedor = (
          proveedor.personalCampoInfo?.comunidad || ''
        ).toUpperCase();

        if (!this.data.productAventura.comunidad?.length) {
          return (
            !comunidadProveedor.includes('HUAYHUASH') &&
            !comunidadProveedor.includes('BLANCA') &&
            !comunidadProveedor.includes('HUARAZ')
          );
        }

        return this.data.productAventura.comunidad?.some((com: string) => {
          const search = com.toUpperCase();
          if (search.includes('CAMICANCHA'))
            return comunidadProveedor.includes('CAMICANCHA');
          if (search.includes('HUILLOQ'))
            return comunidadProveedor.includes('HUILLOQ');
          if (search.includes('LAMAY'))
            return comunidadProveedor.includes('LAMAY');
          if (search.includes('SOCMA'))
            return comunidadProveedor.includes('SOCMA');
          if (search.includes('POROY'))
            return comunidadProveedor.includes('POROY');
          if (search.includes('OCONGATE'))
            return comunidadProveedor.includes('OCONGATE');
          if (search.includes('MACHU PICCHU'))
            return comunidadProveedor.includes('MACHU PICCHU');
          return;
        });
      });
    }

    this.proveedores.sort((a: { nombre: string }, b: { nombre: string }) => {
      const nombreA = a.nombre || '';
      const nombreB = b.nombre || '';
      return nombreA.localeCompare(nombreB, 'es', {
        numeric: true,
        sensitivity: 'base'
      });
    });

    this.filteredProviders = this.proveedores;

    await Promise.all(
      this.uniqueServices.map(async (uniqueService: any) => {
        // array de proveedores que ya están asignados a los servicios con mismo nombre/categoría
        const sameServices = this.data.servicios.filter((service: any) =>
          this.isSameService(service, uniqueService)
        );

        const currentProviderIdsByService = [
          ...new Set(sameServices.map((servicio: any) => servicio.providerId))
        ];

        const proveedoresFiltrados = this.proveedores.filter((proveedor) =>
          currentProviderIdsByService.includes(proveedor.id)
        );

        // lista de proveedores previo a los cambios realizados para saber cuáles fueron agregados o eliminados
        this.currentProviders =
          this.currentProviders.concat(proveedoresFiltrados);

        uniqueService.proveedores = proveedoresFiltrados;

        // Filtrar proveedores que ya tienen OS en otros servicios (orderId)
        const proveedoresConOSEnOtrosServicios = new Set();
        this.data.servicios.forEach((servicio: any) => {
          const tieneOS = Boolean(servicio.orderId);
          if (tieneOS) {
            // Si tiene OS, marcar ese proveedor como bloqueado en otros servicios
            if (!this.isSameService(servicio, uniqueService)) {
              proveedoresConOSEnOtrosServicios.add(servicio.providerId);
            }
          }
        });

        // Solo agregar a allProv los proveedores que no tienen OS en otros servicios
        // O que ya están asignados a este servicio
        uniqueService.allProv = proveedoresFiltrados.filter((proveedor) => {
          const tieneOSEnOtroServicio = proveedoresConOSEnOtrosServicios.has(
            proveedor.id
          );
          const esProveedorActualDeEsteServicio =
            currentProviderIdsByService.includes(proveedor.id);

          const incluir =
            !tieneOSEnOtroServicio || esProveedorActualDeEsteServicio;

          if (!incluir) {
            console.log(
              'Excluido proveedor:',
              proveedor.nombre,
              ' - tieneOSEnOtroServicio:',
              tieneOSEnOtroServicio,
              ' - esProveedorActual:',
              esProveedorActualDeEsteServicio
            );
          }

          return incluir;
        });

        // Mapear información de OS para este servicio único
        const serviciosConOS = sameServices.filter((s: any) =>
          Boolean(s.orderId)
        );
        const proveedoresConOSEsteServicio = new Set<string>(
          serviciosConOS.map((s: any) => s.providerId).filter(Boolean)
        );
        uniqueService.serviciosConOSCount = proveedoresConOSEsteServicio.size;
        uniqueService.hasOS = proveedoresConOSEsteServicio.size > 0;
        uniqueService.proveedorIdsConOS = proveedoresConOSEsteServicio;
        uniqueService.osNumbers = [
          ...new Set(serviciosConOS.map((s: any) => s.orderId).filter(Boolean))
        ];

        uniqueService.selected = uniqueService.proveedores;

        uniqueService.proveedores.map((proveedorAdded: any) => {
          for (const dia of uniqueService.days) {
            if (!this.proveedoresAsignadosPorDia[dia]) {
              this.proveedoresAsignadosPorDia[dia] = [];
            }
            if (
              !this.proveedoresAsignadosPorDia[dia].includes(proveedorAdded)
            ) {
              this.proveedoresAsignadosPorDia[dia].push(proveedorAdded);
            }
          }
        });

        // FETCHING SPECIFIC PROVIDERS FOR THIS SERVICE FROM API
        const nombreServicio_ = uniqueService.nombreServicio
          ? uniqueService.nombreServicio
          : '';
        const categoriaServicio_ =
          uniqueService.categoriaServicio &&
          uniqueService.categoriaServicio !== 'null'
            ? uniqueService.categoriaServicio
            : '';

        try {
          // Querying with empty location to get all providers for the service,
          // then intersecting locally to avoid database case-sensitivity issues and duplicate fetches.
          const result = await firstValueFrom(
            this.fileService.getProvidersByService(
              nombreServicio_,
              categoriaServicio_,
              ''
            )
          );
          const apiProviders = result?.data || [];
          const apiProviderIds = new Set(apiProviders.map((p: any) => p.id));

          // Intersect with this.proveedores to get only available/allowed ones with full details
          let matchedProviders = this.proveedores.filter((p: any) =>
            apiProviderIds.has(p.id)
          );

          // Ensure currently assigned providers for this service are included
          const missingCurrentProviders = this.proveedores.filter(
            (p: any) =>
              currentProviderIdsByService.includes(p.id) &&
              !matchedProviders.some((mp: any) => mp.id === p.id)
          );
          if (missingCurrentProviders.length > 0) {
            matchedProviders = matchedProviders.concat(missingCurrentProviders);
          }

          // Sort by name A-Z ascending
          matchedProviders.sort((a: any, b: any) => {
            const nameA = a.nombre || '';
            const nameB = b.nombre || '';
            return nameA.localeCompare(nameB, 'es', {
              numeric: true,
              sensitivity: 'base'
            });
          });

          uniqueService.filteredProviders = matchedProviders;
          uniqueService.searchQuery = '';
        } catch (err) {
          console.error(
            'Error in getProvidersByService for',
            uniqueService.serviceId,
            err
          );
          uniqueService.filteredProviders = [];
        }
      })
    );

    this.currentProviders = Array.from(new Set(this.currentProviders));
    this.currentProviders = this.currentProviders.filter(
      (el) => el.nombre !== 'EXPLORANDES CUSCO'
    );

    if (this.data.serviceCategory) {
      this.selectedTipoProveedor = this.data.serviceCategory;
      this.applyFilterSelect();
    }

    this.dataSource.data = this.uniqueServices;
    this.dataSource.paginator = this.paginator;

    this.isLoading = false;
  }

  getOsStatusText(element: any): string | null {
    if (!element) return null;
    const conOS = element.serviciosConOSCount || 0;
    if (conOS <= 0) return null;
    const total = element.cantPersonal ?? 1;
    if (conOS >= total) {
      return 'OS generada';
    }
    return `${conOS} de ${total} con OS`;
  }

  getOsTooltip(element: any): string {
    if (!element?.osNumbers?.length)
      return 'Tiene Órdenes de Servicio asignadas';
    return `Órdenes de Servicio: ${element.osNumbers.join(', ')}`;
  }

  isProviderWithOS(serviceIdOrElement: any, providerId: string): boolean {
    if (!this.data?.servicios || !serviceIdOrElement || !providerId)
      return false;
    const isElement =
      typeof serviceIdOrElement === 'object' && serviceIdOrElement !== null;
    return this.data.servicios.some((s: any) => {
      const isMatch = isElement
        ? this.isSameService(s, serviceIdOrElement)
        : s.serviceId === serviceIdOrElement ||
          (this.uniqueServices &&
            this.uniqueServices.some(
              (u: any) =>
                u.serviceId === serviceIdOrElement && this.isSameService(s, u)
            ));
      return isMatch && s.providerId === providerId && Boolean(s.orderId);
    });
  }

  fechasChocan(fechasOcupadas: any, fechaInicio: any, fechaFin: any) {
    if (!fechasOcupadas || !Array.isArray(fechasOcupadas)) {
      return false; // No hay fechas ocupadas
    }
    const inicioComparar = moment.isMoment(fechaInicio)
      ? fechaInicio
      : moment(fechaInicio, 'DD/MM/YYYY', true);
    const finComparar = moment.isMoment(fechaFin)
      ? fechaFin
      : moment(fechaFin, 'DD/MM/YYYY', true);

    if (!inicioComparar.isValid()) return false;
    const finValido = finComparar.isValid() ? finComparar : inicioComparar;

    for (const ocupada of fechasOcupadas) {
      const ocupadaInicio = moment(ocupada.fechaInicio, 'DD/MM/YYYY', true);
      if (!ocupadaInicio.isValid()) continue;

      const ocupadaFin =
        ocupada.fechaFin &&
        moment(ocupada.fechaFin, 'DD/MM/YYYY', true).isValid()
          ? moment(ocupada.fechaFin, 'DD/MM/YYYY', true)
          : ocupadaInicio.clone();

      const seCruzan =
        inicioComparar <= ocupadaFin && finValido >= ocupadaInicio;

      if (seCruzan) {
        if (this.data.productAventura?.objProducto) {
          if (
            ocupada.itineraryId !== this.data.productAventura.itineraryId ||
            ocupada.productId !== this.data.productAventura.objProducto?.id
          ) {
            return true;
          }
        } else {
          if (ocupada.itineraryId !== this.data.productAventura?.itineraryId) {
            return true;
          }
        }
      }
    }
    return false; // No chocan
  }

  getServiceKey(s: any): string {
    if (s?.nombreServicio) {
      return `${s.nombreServicio}_${s.categoriaServicio || ''}`;
    }
    return s?.serviceId || s?.id;
  }

  isSameService(a: any, b: any): boolean {
    if (!a || !b) return false;
    if (
      a.nombreServicio &&
      b.nombreServicio &&
      a.nombreServicio === b.nombreServicio
    ) {
      if (a.categoriaServicio && b.categoriaServicio) {
        return a.categoriaServicio === b.categoriaServicio;
      }
      return true;
    }
    return Boolean(a.serviceId && b.serviceId && a.serviceId === b.serviceId);
  }

  showUniqueServices(services: any[]): any[] {
    const uniqueKeys = new Set<string>();
    const result: any[] = [];

    for (const service of services) {
      const key = this.getServiceKey(service);
      if (!uniqueKeys.has(key)) {
        uniqueKeys.add(key);
        service.days = [service.day];
        result.push(service);
      } else {
        const existingService = result.find(
          (s) => this.getServiceKey(s) === key
        );

        if (existingService && !existingService.days.includes(service.day)) {
          existingService.days.push(service.day);
        }
      }
    }

    result.forEach((el) => {
      el.days.sort((a: string, b: string) => {
        return parseInt(a, 10) - parseInt(b, 10);
      });
    });

    return result.filter((el) => el.cantPersonal !== 0);
  }

  isProviderUnique(provider: any, uniqueProviders: any) {
    return !Array.from(uniqueProviders).some((p: any) => p.id === provider.id);
  }

  // 📊 Helper para agrupar asignaciones por proveedor
  agruparAsignacionesPorProveedor(asignaciones: any[]): any {
    return asignaciones.reduce((acc: any, item: any) => {
      if (!acc[item.idProvider]) {
        acc[item.idProvider] = [];
      }
      acc[item.idProvider].push(item.idRegistro);
      return acc;
    }, {});
  }

  guardar() {
    let asignaciones: { idRegistro: any; idProvider: any }[] = [];

    const newUniqueProviders = new Set();

    this.dataSource.data.forEach((item: any) => {
      item.proveedores?.forEach((provider: any) => {
        if (this.isProviderUnique(provider, newUniqueProviders)) {
          newUniqueProviders.add(provider);
        }
      });
    });

    const uniqueProviderArray = Array.from(newUniqueProviders);

    const proveedoresAgregados = uniqueProviderArray.filter(
      (proveedor: any) =>
        !this.currentProviders.some((p: any) => p.id === proveedor.id)
    );

    const proveedoresEliminados = this.currentProviders.filter(
      (proveedor: any) =>
        !uniqueProviderArray.some((p: any) => p.id === proveedor.id)
    );

    const request = {
      serviceIds: this.data.servicios.map((s: any) => s.id),

      serviciosUnique: this.dataSource.data.map((s: any) => ({
        serviceId: s.serviceId,
        allProv: s.allProv.map((p: any) => p.id)
      }))
    };

    this.fileService
      .changeMultipleProviders(request)
      .subscribe(async (result) => {
        if (result.changeMultipleProviders.success) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Se asignaron los proveedores correctamente',
            showConfirmButton: false,
            timer: 4000
          });

          if (result.changeMultipleProviders.staleData) {
            Swal.fire({
              icon: 'warning',
              title: 'Información desactualizada',
              text: 'Mientras el diálogo estuvo abierto se generaron nuevas OS. Algunos proveedores no pudieron ser desasignados porque tienen servicios protegidos. Se recomienda recargar la página.'
            });
          }

          const fechaFinCalculada =
            this.data.productAventura?.fechaFinProducto ||
            this.data.productAventura?.fechaLiberacion ||
            this.data.productAventura?.fechaInicioProducto;

          try {
            await Promise.all(
              proveedoresEliminados.map(async (proveedor: any) => {
                const data = {
                  fechaInicio: this.data.productAventura.fechaInicioProducto,
                  fechaFin: fechaFinCalculada,
                  itineraryId: this.data.productAventura.itineraryId,
                  productId: this.data.productAventura.objProducto?.id
                };

                await lastValueFrom(
                  this.aventuraService.deleteFechasOcupadas(proveedor.id, data)
                );

                const toDelete = proveedor.fechasOcupadas?.findIndex(
                  (item: any) =>
                    item.itineraryId === data.itineraryId &&
                    item.productId === data.productId &&
                    item.fechaInicio === data.fechaInicio
                );

                if (toDelete !== -1 && toDelete !== undefined) {
                  proveedor.fechasOcupadas.splice(toDelete, 1);
                }
              })
            );

            await Promise.all(
              proveedoresAgregados.map(async (proveedor: any) => {
                const data = {
                  fechaInicio: this.data.productAventura.fechaInicioProducto,
                  fechaFin: fechaFinCalculada,
                  itineraryId: this.data.productAventura.itineraryId,
                  productId: this.data.productAventura.objProducto?.id,
                  productName:
                    this.data.productAventura.objProducto?.nombre ||
                    this.data.productAventura.nombreItinerario ||
                    '',
                  fileNumber: this.data.productAventura.fileNumber,
                  categoriaServicio: this.data.serviceCategory
                };
                await lastValueFrom(
                  this.aventuraService.addFechasOcupadas(proveedor.id, data)
                );

                proveedor.fechasOcupadas
                  ? proveedor.fechasOcupadas.push(data)
                  : (proveedor.fechasOcupadas = [data]);
              })
            );
          } catch (syncError) {
            console.error('Error al sincronizar fechasOcupadas:', syncError);
          }

          const servicesMap = new Map<
            string,
            {
              id: string;
              providerId: string;
              orderId?: string | null;
            }
          >(result.changeMultipleProviders.services.map((s: any) => [s.id, s]));

          this.data.servicios.forEach((service: any) => {
            const updated = servicesMap.get(service.id);

            if (!updated) return;

            service.providerId = updated.providerId;
            service.orderId = updated.orderId ?? service.orderId;
          });

          this.dialogRef.close({
            services: this.data.servicios,
            added: proveedoresAgregados,
            deleted: proveedoresEliminados
          });
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Ocurrió un error',
            showConfirmButton: false,
            timer: 3000
          });
        }
      });
  }

  applyFilterSelect() {
    let newFilteredProviders: any = this.proveedores;
    // if (this.selectedTipoProveedor) {
    //   newFilteredProviders = newFilteredProviders?.filter((proveedor: any) => {
    //     if (this.selectedTipoProveedor === 'GUIA') {
    //       return proveedor.tipoProveedor === this.selectedTipoProveedor;
    //     } else if (this.selectedTipoProveedor === 'CARPEROBANERO') {
    //       return (
    //         proveedor.categoriaProveedor === 'CARPERO' ||
    //         proveedor.categoriaProveedor === 'BAÑERO'
    //       );
    //     } else if (this.selectedTipoProveedor === 'BAÑERO') {
    //       return proveedor.categoriaProveedor === 'BAÑERO';
    //     } else if (this.selectedTipoProveedor === 'COCINERO') {
    //       return (
    //         proveedor.categoriaProveedor === 'COCINERO' ||
    //         proveedor.categoriaProveedor === 'ASISTENTECOCINA'
    //       );
    //     } else if (
    //       this.selectedTipoProveedor === 'PORTEADOR' ||
    //       this.selectedTipoProveedor === 'PORTEADOREXTRA'
    //     ) {
    //       return (
    //         proveedor.categoriaProveedor === 'JEFEPORTEADOR' ||
    //         proveedor.categoriaProveedor === 'PORTEADOR' ||
    //         proveedor.categoriaProveedor === 'PORTEADOREXTRA' ||
    //         proveedor.categoriaProveedor === 'BAÑERO'
    //       );
    //     } else if (this.selectedTipoProveedor === 'ARRIERO') {
    //       return (
    //         proveedor.categoriaProveedor === 'ARRIERO' ||
    //         proveedor.categoriaProveedor === 'ARRIEROCABALLO' ||
    //         proveedor.categoriaProveedor === 'ARRIEROCARGA' ||
    //         proveedor.categoriaProveedor === 'ARRIEROSILLA'
    //       );
    //     } else if (this.selectedTipoProveedor === 'ACEMILA') {
    //       return (
    //         proveedor.categoriaProveedor === 'ACEMILA' ||
    //         proveedor.categoriaProveedor === 'ACEMILACARGA' ||
    //         proveedor.categoriaProveedor === 'ACEMILASILLA'
    //       );
    //     } else
    //       return proveedor.categoriaProveedor === this.selectedTipoProveedor;
    //   });
    // } else {
    // }

    this.dataSource.data.map((uniqueService: any) => {
      uniqueService.proveedores = uniqueService.allProv;
    });
    this.filteredProviders = newFilteredProviders;
  }

  normalizeText(text?: string): string {
    return (text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  onSearchProvider(element: any, text: string): void {
    element.searchQuery = text;
  }

  clearSearchProvider(element: any, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    element.searchQuery = '';
  }

  isProviderVisible(proveedor: any, searchQuery?: string): boolean {
    if (!searchQuery || !searchQuery.trim()) {
      return true;
    }
    const query = this.normalizeText(searchQuery);
    const nombre = this.normalizeText(proveedor?.nombre);
    const comunidad = this.normalizeText(
      proveedor?.personalCampoInfo?.comunidad
    );
    return nombre.includes(query) || comunidad.includes(query);
  }

  hasVisibleProviders(element: any): boolean {
    if (!element.filteredProviders || element.filteredProviders.length === 0) {
      return false;
    }
    if (!element.searchQuery || !element.searchQuery.trim()) {
      return true;
    }
    return element.filteredProviders.some((p: any) =>
      this.isProviderVisible(p, element.searchQuery)
    );
  }

  onProviderDropdownOpened(isOpen: boolean, element: any, index: number): void {
    if (isOpen) {
      setTimeout(() => {
        const panel = document.querySelector('.custom-filter-select-panel');
        if (panel) {
          panel.scrollTop = 0;
        }
        const input = document.getElementById(
          `search-provider-input-${index}`
        ) as HTMLInputElement;
        if (input) {
          input.focus();
        }
      }, 100);
    } else {
      element.searchQuery = '';
    }
  }

  onSearchKeydown(
    event: KeyboardEvent,
    element: any,
    selectRef: MatSelect
  ): void {
    if (event.key === 'Escape') {
      selectRef.close();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const visible = (element.filteredProviders || []).filter((p: any) =>
        this.isProviderVisible(p, element.searchQuery)
      );
      if (visible.length === 1) {
        this.toggleProviderSelection(element, visible[0]);
      }
    } else {
      event.stopPropagation();
    }
  }

  toggleProviderSelection(element: any, provider: any): void {
    element.proveedores = element.proveedores || [];
    const exists = element.proveedores.some((p: any) => p.id === provider.id);
    if (exists) {
      element.proveedores = element.proveedores.filter(
        (p: any) => p.id !== provider.id
      );
    } else {
      element.proveedores = [...element.proveedores, provider];
    }
    this.changed(element);
  }
}
